import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Mumbaioutstationcabs() {



    const cardData = {




keyword: "Mumbai Outstation Cabs",

headingDescription: "Shreesha Tours & Travels provides reliable and affordable Mumbai outstation cab services for business travel, family vacations, corporate tours, weekend getaways, airport transfers, religious trips, and long-distance journeys across Maharashtra, Goa, Karnataka, Gujarat, and other destinations in India. We offer one-way cabs, round-trip taxi services, multi-city travel, and customized outstation packages with experienced chauffeurs and well-maintained vehicles. Our fleet includes Sedan, Swift Dzire, Ertiga, SUV, Innova, Innova Crysta, Tempo Traveller, Urbania, Mini Bus, and luxury vehicles suitable for solo travelers, families, corporate groups, and large tour groups. With doorstep pickup anywhere in Mumbai, transparent pricing, flexible travel schedules, easy online booking, and 24/7 customer support, Shreesha Tours & Travels ensures a safe, comfortable, and hassle-free outstation travel experience. Whether you are planning a hill station holiday, beach vacation, pilgrimage tour, corporate meeting, destination wedding, or family outing, our Mumbai outstation cab service delivers professional service, clean vehicles, punctual drivers, and a memorable journey from start to finish.",

topPlaces: [
  {
    title: "Pune",
    description: "Pune is one of the most popular outstation destinations from Mumbai, known for its IT parks, educational institutions, historical forts, shopping malls, and pleasant weather. Travelers frequently choose private cabs for comfortable business trips, family visits, weekend getaways, and airport transfers between Mumbai and Pune."
  },
  {
    title: "Lonavala",
    description: "Lonavala is a famous hill station located between Mumbai and Pune, attracting visitors with its waterfalls, green valleys, viewpoints, caves, and pleasant climate. It is an ideal destination for couples, families, corporate outings, and monsoon road trips."
  },
  {
    title: "Mahabaleshwar",
    description: "Mahabaleshwar is a scenic hill station known for strawberry farms, lush forests, boating, waterfalls, and breathtaking viewpoints. It is one of the preferred weekend destinations for travelers seeking relaxation and nature."
  },
  {
    title: "Nashik",
    description: "Nashik is a spiritual and wine tourism destination famous for Trimbakeshwar Temple, vineyards, riverfront attractions, and cultural heritage. It is a popular choice for pilgrimage tours, business travel, and family vacations from Mumbai."
  },
  {
    title: "Shirdi",
    description: "Shirdi is one of India's most visited pilgrimage destinations, attracting millions of devotees to the Sai Baba Temple every year. Private outstation cabs provide convenient and comfortable travel for families, senior citizens, and pilgrimage groups."
  },
  {
    title: "Goa",
    description: "Goa is India's most loved beach destination, famous for its sandy beaches, luxury resorts, Portuguese heritage, nightlife, churches, and water sports. Travelers often book private cabs from Mumbai for comfortable coastal road trips and holiday packages."
  },
  {
    title: "Kolhapur",
    description: "Kolhapur is known for the Mahalaxmi Temple, historic forts, traditional cuisine, shopping, and rich cultural heritage. It is a popular destination for religious tours, family travel, and Maharashtra sightseeing."
  },
  {
    title: "Aurangabad",
    description: "Aurangabad is a heritage city famous for Ajanta and Ellora Caves, Bibi Ka Maqbara, Daulatabad Fort, and historical monuments. It is a preferred destination for history lovers, educational tours, and family holidays."
  },
  {
    title: "Hyderabad",
    description: "Hyderabad is a major business and IT hub known for Charminar, Golconda Fort, Ramoji Film City, technology parks, and world-famous cuisine. It is a popular destination for corporate travelers as well as tourists."
  },
  {
    title: "Bangalore",
    description: "Bangalore is India's leading technology city known for multinational companies, business parks, shopping destinations, gardens, and vibrant nightlife. Many travelers choose outstation cabs from Mumbai for comfortable long-distance business and leisure travel."
  }
],




"services": [
  {
    "name": "Best Outstation Cab Service in Mumbai",
    "description": "Book the Best Outstation Cab Service in Mumbai for safe, comfortable, and reliable long-distance travel with professional chauffeurs and well-maintained AC vehicles. Choose from Sedan, Ertiga, Innova Crysta, and SUV cabs for family trips, business travel, holiday tours, and one way or round trip journeys across India."
  },
  {
    "name": "Outstation Cab Booking Mumbai",
    "description": "Complete Outstation Cab Booking Mumbai with instant confirmation, affordable fares, and multiple vehicle options. Enjoy convenient doorstep pickup, experienced drivers, and comfortable travel for every outstation destination."
  },
  {
    "name": "Outstation Cab Service in Mumbai",
    "description": "Hire Outstation Cab Service in Mumbai for smooth interstate and intercity travel with clean AC vehicles, skilled chauffeurs, and transparent pricing. Travel comfortably for business, family vacations, and weekend getaways."
  },
  {
    "name": "Outstation Taxi Service in Mumbai",
    "description": "Choose Outstation Taxi Service in Mumbai for reliable transportation with premium vehicles, professional drivers, and flexible one way and round trip booking options. Enjoy safe and comfortable journeys to destinations across India."
  },
  {
    "name": "Cab Booking in Mumbai for Outstation",
    "description": "Book Cab Booking in Mumbai for Outstation travel with easy online reservations, competitive pricing, and well-maintained vehicles. Select from Sedan, Ertiga, Innova Crysta, and SUV cabs according to your travel requirements."
  },
  {
    "name": "Cab Service in Mumbai for Outstation",
    "description": "Hire Cab Service in Mumbai for Outstation journeys with professional chauffeurs, comfortable vehicles, and reliable customer support. Ideal for family travel, corporate trips, sightseeing, and long-distance transportation."
  },
  {
    "name": "Car for Outstation from Mumbai",
    "description": "Book Car for Outstation from Mumbai with spacious AC vehicles and experienced drivers for comfortable travel. Enjoy safe and affordable transportation for vacations, business tours, and interstate journeys."
  },
  {
    "name": "Car Hire for Outstation in Mumbai",
    "description": "Choose Car Hire for Outstation in Mumbai for chauffeur-driven travel with premium comfort and flexible travel plans. Get reliable transportation for personal, family, and business travel."
  },
  {
    "name": "Car on Rent for Outstation in Mumbai",
    "description": "Reserve Car on Rent for Outstation in Mumbai with affordable rental packages, clean vehicles, and experienced drivers. Perfect for weekend trips, holidays, airport transfers, and corporate travel."
  },
  {
    "name": "Cheapest Outstation Cabs from Mumbai",
    "description": "Find Cheapest Outstation Cabs from Mumbai with budget-friendly fares, professional chauffeurs, and comfortable AC cars. Enjoy affordable one way and round trip travel without compromising safety or quality."
  },
  {
    "name": "Hire a Cab in Mumbai",
    "description": "Hire a Cab in Mumbai for convenient local and outstation travel with reliable drivers and comfortable vehicles. Choose from multiple cab categories for family, business, and leisure trips."
  },
  {
    "name": "Hire Cab Mumbai",
    "description": "Book Hire Cab Mumbai services for quick, reliable, and comfortable transportation with experienced chauffeurs. Enjoy safe travel with Sedan, Ertiga, Innova Crysta, and SUV vehicles."
  },
  {
    "name": "Mumbai Outstation Taxi",
    "description": "Choose Mumbai Outstation Taxi for safe interstate travel with clean AC vehicles, affordable pricing, and professional drivers. Travel comfortably for family vacations, business meetings, and holiday tours."
  },
  {
    "name": "Outstation Cars in Mumbai",
    "description": "Book Outstation Cars in Mumbai for premium chauffeur-driven travel with multiple vehicle choices and transparent pricing. Enjoy reliable transportation for every outstation journey."
  },
  {
    "name": "Taxi Service in Mumbai for Outstation",
    "description": "Hire Taxi Service in Mumbai for Outstation travel with experienced chauffeurs, comfortable seating, and flexible booking options. Ideal for long-distance family, corporate, and personal travel."
  },
  {
    "name": "Mumbai to Outstation Cabs",
    "description": "Book Mumbai to Outstation Cabs for reliable travel across Maharashtra and India with professional drivers and well-maintained vehicles. Enjoy one way and round trip services at competitive rates."
  },
  {
    "name": "Mumbai to Shirdi Cabs Round Trip",
    "description": "Choose Mumbai to Shirdi Cabs Round Trip for comfortable pilgrimage travel with affordable packages, spacious vehicles, and experienced chauffeurs. Perfect for family and group temple visits."
  },
  {
    "name": "Mumbai to Lonavala Round Trip Taxi",
    "description": "Book Mumbai to Lonavala Round Trip Taxi for relaxing weekend getaways with comfortable vehicles, flexible schedules, and professional drivers. Enjoy safe and enjoyable travel throughout your journey."
  },
  {
    "name": "Mumbai to Shirdi Round Trip Taxi Fare",
    "description": "Check Mumbai to Shirdi Round Trip Taxi Fare with transparent pricing, affordable packages, and quality cab services. Travel comfortably with Sedan, Ertiga, Innova Crysta, and SUV options."
  },
  {
    "name": "Mumbai to Hyderabad Cab",
    "description": "Book Mumbai to Hyderabad Cab for safe and comfortable interstate travel with professional chauffeurs, premium vehicles, and flexible one way or round trip options."
  },
  {
    "name": "Mumbai to Bangalore Cab",
    "description": "Hire Mumbai to Bangalore Cab for reliable long-distance travel with spacious vehicles, experienced drivers, and affordable travel packages for family and corporate journeys."
  },
  {
    "name": "Mumbai to Bangalore Taxi",
    "description": "Choose Mumbai to Bangalore Taxi for smooth interstate transportation with clean AC vehicles, professional chauffeurs, and transparent pricing."
  },
  {
    "name": "Mumbai to Telangana Cab",
    "description": "Book Mumbai to Telangana Cab for convenient interstate travel with comfortable vehicles, reliable drivers, and affordable fares for personal and business trips."
  },
  {
    "name": "Mumbai to Belgaum Taxi",
    "description": "Reserve Mumbai to Belgaum Taxi for comfortable outstation travel with premium vehicles, experienced chauffeurs, and flexible travel schedules."
  },
  {
    "name": "Mumbai to Belgaum Cab",
    "description": "Choose Mumbai to Belgaum Cab for reliable transportation with spacious AC vehicles, competitive pricing, and professional drivers for family and business travel."
  },
  {
    "name": "Mumbai to Chennai Cab",
    "description": "Book Mumbai to Chennai Cab for safe long-distance travel with experienced chauffeurs, luxury vehicle options, and convenient one way and round trip booking facilities."
  },
  {
    "name": "Reliable Outstation Cab Mumbai",
    "description": "Choose Reliable Outstation Cab Mumbai for dependable long-distance transportation with well-maintained vehicles, trained drivers, transparent fares, and excellent customer support for every journey."
  }
],
"tableData": [
  ["Best Outstation Cab Service in Mumbai", "Outstation Cab Booking Mumbai"],
  ["Outstation Cab Service in Mumbai", "Outstation Taxi Service in Mumbai"],
  ["Cab Booking in Mumbai for Outstation", "Cab Service in Mumbai for Outstation"],
  ["Car for Outstation from Mumbai", "Car Hire for Outstation in Mumbai"],
  ["Car on Rent for Outstation in Mumbai", "Cheapest Outstation Cabs from Mumbai"],
  ["Hire a Cab in Mumbai", "Hire Cab Mumbai"],
  ["Mumbai Outstation Taxi", "Outstation Cars in Mumbai"],
  ["Taxi Service in Mumbai for Outstation", "Mumbai to Outstation Cabs"],
  ["Mumbai to Shirdi Cabs Round Trip", "Mumbai to Lonavala Round Trip Taxi"],
  ["Mumbai to Shirdi Round Trip Taxi Fare", "Mumbai to Hyderabad Cab"],
  ["Mumbai to Bangalore Cab", "Mumbai to Bangalore Taxi"],
  ["Mumbai to Telangana Cab", "Mumbai to Belgaum Taxi"],
  ["Mumbai to Belgaum Cab", "Mumbai to Chennai Cab"],
  ["Reliable Outstation Cab Mumbai", ""]
],





  whychoose: [
  {
    WhyChooseheading: "Comfortable Mumbai Outstation Cabs",
    WhyChoosedescription: "Shreesha Tours & Travels offers dependable Mumbai outstation cab services for business trips, family vacations, pilgrimages, and weekend getaways with clean, comfortable, and well-maintained vehicles."
  },
  {
    WhyChooseheading: "Travel Across Maharashtra & India",
    WhyChoosedescription: "Whether you're planning a trip from Mumbai to Pune, Nashik, Shirdi, Goa, Surat, Ahmedabad, Bangalore, Hyderabad, or any destination across India, we provide convenient outstation taxi solutions."
  },
  {
    WhyChooseheading: "Choose the Right Vehicle",
    WhyChoosedescription: "Book a Swift Dzire, Sedan, Ertiga, Innova, Innova Crysta, SUV, Tempo Traveller, or Premium Cab based on your group size, luggage, and travel preferences."
  },
  {
    WhyChooseheading: "Flexible One Way & Round Trip Services",
    WhyChoosedescription: "Select one-way cabs, round-trip taxis, multi-city journeys, or customized travel plans designed to match your schedule and destination."
  },
  {
    WhyChooseheading: "Professional & Experienced Chauffeurs",
    WhyChoosedescription: "Our trained drivers focus on safe driving, timely pickups, and smooth highway travel, ensuring a comfortable experience throughout your journey."
  },
  {
    WhyChooseheading: "Ideal for Every Travel Requirement",
    WhyChoosedescription: "Our Mumbai outstation cab service is suitable for corporate travel, family holidays, airport transfers, weddings, sightseeing tours, educational trips, and personal travel."
  },
  {
    WhyChooseheading: "Clean, Spacious & Well-Maintained Fleet",
    WhyChoosedescription: "Every vehicle is regularly serviced and maintained to provide a comfortable ride with spacious seating, clean interiors, and reliable performance."
  },
  {
    WhyChooseheading: "Quick & Hassle-Free Cab Booking",
    WhyChoosedescription: "Shreesha Tours & Travels provides easy booking assistance, transparent fare information, and prompt customer support to help you plan your outstation journey without any hassle."
  }
]

};

const faqData = [
  {
    question: "Does Shreesha Tours & Travels provide Mumbai Outstation Cabs?",
    answer: "Yes, we provide Mumbai outstation cab services to destinations across Maharashtra and various cities throughout India."
  },
  {
    question: "Can I book a one-way outstation cab from Mumbai?",
    answer: "Yes, one-way taxi services are available for travellers who need direct transportation to their destination."
  },
  {
    question: "Which vehicles are available for outstation travel?",
    answer: "You can choose from Swift Dzire, Sedan, Ertiga, Innova, Innova Crysta, SUVs, Tempo Travellers, and premium vehicles."
  },
  {
    question: "Do you offer round-trip outstation taxi services?",
    answer: "Yes, round-trip packages are available with flexible return schedules according to your travel plans."
  },
  {
    question: "Can I book a cab for multiple cities?",
    answer: "Yes, customized multi-city and multi-day taxi packages are available for business, leisure, and family travel."
  },
  {
    question: "Do you provide Mumbai Airport pickup for outstation trips?",
    answer: "Yes, pickup is available from Mumbai Airport, hotels, railway stations, homes, offices, and other preferred locations."
  },
  {
    question: "Are your cabs suitable for family vacations?",
    answer: "Yes, our spacious vehicles are ideal for families, groups, senior citizens, and long-distance travel."
  },
  {
    question: "Are tolls and parking charges included in the fare?",
    answer: "Tolls, parking, permits, and other applicable charges depend on the selected package and are explained before booking."
  },
  {
    question: "Is Mumbai outstation cab service available 24/7?",
    answer: "Yes, Shreesha Tours & Travels offers booking assistance for both scheduled and urgent outstation travel."
  },
  {
    question: "How can I book Mumbai Outstation Cabs?",
    answer: "Simply share your travel date, pickup location, destination, passenger details, and preferred vehicle to receive a quotation and booking confirmation."
  }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Rohit Mehta",
    feedback: "We hired an outstation cab from Mumbai through Shreesha Tours & Travels for our family holiday. The vehicle was clean, the driver was courteous, and the journey was comfortable from start to finish.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Neha Shah",
    feedback: "Excellent outstation taxi service with timely pickup and a well-maintained Innova Crysta. Shreesha Tours & Travels made our long-distance trip smooth and hassle-free.",
    rating: 5
  }
];







    const Images = [
        { place: "/images/keyword/1.jpg", text: "Mumbai Outstation Cabs", link: "Mumbai-Outstation-Cabs" },
        { place: "/images/keyword/2.jpg", text: "Mumbai to Mahabaleshwar Cab", link: "Mumbai-to-Mahabaleshwar-Cab" },
        { place: "/images/keyword/3.jpg", text: "Mumbai to Goa Cabs", link: "Mumbai-to-Goa-Cabs" },
        { place: "/images/keyword/4.jpg", text: "Mumbai to Shirdi Cab", link: "Mumbai-to-Shirdi-Cab" },
        { place: "/images/keyword/5.jpg", text: "Mumbai to Nashik Cab", link: "Mumbai-to-Nashik-Cab" },
        { place: "/images/keyword/6.jpg", text: "Mumbai to Kolhapur Cab", link: "Mumbai-to-Kolhapur-Cab" },
        { place: "/images/keyword/7.jpg", text: "Mumbai to Pune Cab", link: "Mumbai-to-Pune-Cab" },
        { place: "/images/keyword/8.jpg", text: "Mumbai to Aurangabad Cab", link: "Mumbai-to-Aurangabad-Cab" },
        { place: "/images/keyword/9.jpg", text: "Mumbai to Bhimashankar Cab", link: "Mumbai-to-Bhimashankar-Cab" },
        { place: "/images/keyword/10.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "Mumbai-to-Ashtavinayak-Cab-Service" },
        { place: "/images/keyword/11.jpg", text: "Mumbai to 5 Jyotirlinga Cab", link: "Mumbai-to-5-Jyotirlinga-Cab" },
        { place: "/images/keyword/12.jpg", text: "Mumbai to Lonavala Cab", link: "Mumbai-to-Lonavala-Cab" },
        { place: "/images/keyword/13.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "Mumbai-to-Konkan-Darshan-Cab-Booking" },
        { place: "/images/keyword/14.jpg", text: "Mumbai to Alibaug Cab", link: "Mumbai-to-Alibaug-Cab" },
        { place: "/images/keyword/15.jpg", text: "Mumbai to Ahmednagar Cab", link: "Mumbai-to-Ahmednagar-Cab" },
        { place: "/images/keyword/16.jpg", text: "Mumbai to Matheran Cab", link: "Mumbai-to-Matheran-Cab" },
        { place: "/images/keyword/17.jpg", text: "Mumbai to Jalgaon Cab Booking / Dhule", link: "Mumbai-to-Jalgaon-Cab-Booking-Dhule" },
        { place: "/images/keyword/18.jpg", text: "Mumbai to Lavasa Cab", link: "Mumbai-to-Lavasa-Cab" },
        { place: "/images/keyword/19.jpg", text: "Mumbai to Panchgani Cab", link: "Mumbai-to-Panchgani-Cab" },
        { place: "/images/keyword/20.jpg", text: "Mumbai to Khandala Taxi Fare", link: "Mumbai-to-Khandala-Taxi-Fare" },
        { place: "/images/keyword/21.jpg", text: "Mumbai to Surat Cab", link: "Mumbai-to-Surat-Cab" },
        { place: "/images/keyword/22.jpg", text: "Mumbai to Ahmedabad Cab", link: "Mumbai-to-Ahmedabad-Cab" },
        { place: "/images/keyword/23.jpg", text: "Mumbai to Narmada Parikrama Cab Booking", link: "Mumbai-to-Narmada-Parikrama-Cab-Booking" },
        { place: "/images/keyword/24.jpg", text: "Mumbai to Baroda Cabs", link: "Mumbai-to-Baroda-Cabs" },
        { place: "/images/keyword/25.jpg", text: "Mumbai to Daman Taxi", link: "Mumbai-to-Daman-Taxi" },
    ];











const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Mumbai Outstation Cabs",
  "image": "https://www.shreeshatravels.com/assets/images/mumbai-outstation-cabs.webp",
  "description":
    "Book Mumbai Outstation Cabs with Shreesha Tours & Travels for safe, comfortable, and affordable outstation taxi services. We provide one-way and round-trip cabs from Mumbai to destinations across Maharashtra, Goa, Gujarat, Karnataka, and all over India with Sedan, Ertiga, SUV, Innova, and Innova Crysta cabs available 24x7 for business travel, family trips, airport transfers, and holiday tours.",
  "brand": {
    "@type": "Brand",
    "name": "Shreesha Tours & Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "8517"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹12/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://www.shreeshatravels.com/mumbai-outstation-cabs"
  }
};



    return (
        <div>
<Helmet>
  <title>Mumbai Outstation Cabs | Affordable Taxi Service | +91 8355835813</title>

  <meta
    name="description"
    content="Book Mumbai Outstation Cabs with Shreesha Travels for reliable one-way and round-trip taxi services. Hire Sedan, Ertiga, SUV, Innova, and Innova Crysta for comfortable outstation travel from Mumbai with affordable fares and 24x7 online cab booking."
  />

  <meta
    name="keywords"
    content="Mumbai Outstation Cabs, Best Outstation Cab Service in Mumbai, Outstation Cab Booking Mumbai, Outstation Cab Service in Mumbai, Outstation Taxi Service in Mumbai, Cab Booking in Mumbai for Outstation, Mumbai Outstation Taxi, Mumbai Outstation Cab, Mumbai Outstation Taxi Service, One Way Outstation Cab Mumbai, Round Trip Cab Mumbai, Mumbai Car Rental for Outstation, Mumbai Intercity Cab Service, Online Outstation Cab Booking Mumbai, Cheap Outstation Cab Mumbai"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


            <section className="page-banner">
                <div className="page-banner-container">
                    <h2>
                        {cardData.keyword}
                    </h2>
                </div>
            </section>


















            <section>
                <div className="container-fluid p-0" >
                    <div className="row container-fluid px-md-2">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/1.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Shreesha Tours & Travels: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>

                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>





                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div className="service-card" key={index}>
                                        <div className="service-content">
                                            <h4>{service.name}</h4>
                                            <span className="line"></span>
                                            <p>{service.description}</p>
                                        </div>

                                        <div className="service-icon">
                                            <i className="fas fa-arrow-right"></i>
                                        </div>
                                    </div>
                                ))}
                            </div>

                            <div className="keyword-grid">
                                {cardData.tableData.flat().map((keyword, index) => (
                                    <div key={index} className="keyword-item">
                                        <span className="keyword-bullet">-</span>
                                        {keyword}
                                    </div>
                                ))}
                            </div>



                            <div id="why-choose-section" className="why-choose-section">

                                <h2 className="section-title text-dark">
                                    Why Choose <span>Shreesha Tours & Travels</span>
                                </h2>

                                <div className="bento-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div className="bento-card" key={index}>

                                            <div className="bento-number">
                                                {String(index + 1).padStart(2, "0")}
                                            </div>

                                            <h4>{item.WhyChooseheading}</h4>

                                            <p>{item.WhyChoosedescription}</p>

                                        </div>
                                    ))}
                                </div>

                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Shreesha Tours & Travels </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title=""
                                                    subtitle=""
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fas fa-phone-alt"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+918355835813 " className="pc-call">+91 8355835813 </a>
                                        </div>
                                        <div className="pc-list">
                                            <a href="tel:+919930929439 " className="pc-call">+91 9930929439 </a>
                                        </div>
                                        <div className="pc-list">
                                            <a href="tel:+919022432779 " className="pc-call">+91 9022432779 </a>
                                        </div>
                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/91919930929439 "
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+918355835813 " className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-envelope"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@shreeshatravels.com" className="pc-email">
                                            booking@shreeshatravels.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-location-dot"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Shreesha Tours & Travels</strong><br />
                                            Office 125, Saishraddha CHS,
                                            Plot No 47, Near Koparkhairane Police Station,
                                            Sector 5, Sector 4,Ghansoli, Navi Mumbai,
                                            Maharashtra, India- 400701




                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Mumbaioutstationcabs;